const PERMISSION_KEY= "core:promotion_coupon_redemption";
const PAGE_URL = {
    PROMOTION_COUPON_REDEMPTION_PAGE: "/admin/core/promotion-coupon-redemption"
}

export {PERMISSION_KEY, PAGE_URL}

